export default __webpack_public_path__ + "static/media/Missionary's Bracers.15a90573.jpg";